import type { ComponentConfig } from '@puckeditor/core'

export interface SpacerProps {
    height: number
}

export const SpacerBlock: ComponentConfig<SpacerProps> = {
    label: 'Spacer',
    defaultProps: {
        height: 24,
    },
    fields: {
        height: { type: 'number', label: 'Height (px)', min: 4, max: 200 },
    },
    render: ({ height }) => (
        <div style={{ height, width: '100%' }} />
    ),
}
